export const CopyIcon = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_646_29755)">
        <path
          d="M8 1H2C1.45 1 1 1.45 1 2V9H2V2H8V1ZM9.5 3H4C3.45 3 3 3.45 3 4V11C3 11.55 3.45 12 4 12H9.5C10.05 12 10.5 11.55 10.5 11V4C10.5 3.45 10.05 3 9.5 3ZM9.5 11H4V4H9.5V11Z"
          fill="#797E8B"
        />
      </g>
      <defs>
        <clipPath id="clip0_646_29755">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
